import {
    URL_EMAIL_VERIFICATION,
    URL_FORGOT_PASSWORD,
    URL_LOGIN,
    URL_REGISTER,
    URL_RESET_PASSWORD,
} from "../config";

export function getFullPath(relativePath: string) {
    const host = window.location.origin;

    if (relativePath.startsWith("/")) {
        relativePath = relativePath.slice(1);
    }

    if (relativePath.endsWith("/")) {
        relativePath = relativePath.slice(0, -1);
    }

    return `${host}/${relativePath}`;
}

export function normalizePathname(pathname: string) {
    if (!pathname) {
        return "/";
    }

    if (pathname.length > 1 && pathname.endsWith("/")) {
        return pathname.slice(0, -1);
    }

    return pathname;
}

export function isPublicAuthRoute(pathname: string) {
    const normalizedPathname = normalizePathname(pathname);

    return [URL_REGISTER, URL_FORGOT_PASSWORD, URL_RESET_PASSWORD].includes(normalizedPathname);
}

export function buildLoginRedirectUrl() {
    const loginUrl = getFullPath(URL_LOGIN);
    const normalizedPathname = normalizePathname(window.location.pathname);

    if (normalizedPathname === URL_LOGIN) {
        return loginUrl;
    }

    const returnTo = window.btoa(`${window.location.pathname}${window.location.search}`);

    return `${loginUrl}?returnTo=${returnTo}`;
}

export function getAuthenticatedRedirectUrl(validated: boolean, returnToPath?: string) {
    if (!validated) {
        return getFullPath(URL_EMAIL_VERIFICATION);
    }

    return getFullPath(returnToPath || "/menu");
}

function normalizeBase64(value: string) {
    const normalizedValue = value.replace(/\s/g, "+").replace(/-/g, "+").replace(/_/g, "/");
    const paddingLength = normalizedValue.length % 4;

    if (!paddingLength) {
        return normalizedValue;
    }

    return normalizedValue.padEnd(normalizedValue.length + (4 - paddingLength), "=");
}

export function isValidReturnToPath(path: string) {
    if (!path || !path.startsWith("/") || path.startsWith("//")) {
        return false;
    }

    try {
        const returnToUrl = new URL(path, window.location.origin);
        return returnToUrl.origin === window.location.origin;
    } catch {
        return false;
    }
}

export function getReturnToPath(encodedReturnTo?: string | null) {
    if (!encodedReturnTo) {
        return undefined;
    }

    try {
        const decodedReturnTo = window.atob(normalizeBase64(encodedReturnTo)).trim();

        if (!isValidReturnToPath(decodedReturnTo)) {
            return undefined;
        }

        return decodedReturnTo;
    } catch {
        return undefined;
    }
}

export function removeSearchParamFromCurrentUrl(paramName: string) {
    const currentUrl = new URL(window.location.href);

    if (!currentUrl.searchParams.has(paramName)) {
        return;
    }

    currentUrl.searchParams.delete(paramName);

    const search = currentUrl.searchParams.toString();
    const nextUrl = `${currentUrl.pathname}${search ? `?${search}` : ""}${currentUrl.hash}`;

    window.history.replaceState(window.history.state, "", nextUrl);
}
